<template>
	<div class="Page" :class="classes">
		<!-- @slot Only CloPageSection should go here -->
		<slot />
	</div>
</template>

<script>
import CloPageSection from '@/base/CloPage/CloPageSection';

export default {
	components: { CloPageSection },
	data() {
		return {};
	},
	props: {
		/**
		 * Adds dropshadow on sides of page
		 */
		elevation: {
			type: Boolean,
			default: false,
		},
		/**
		 * Page background color
		 */
		background: {
			type: String,
			default: null,
		},
		/**
		 * Fixed position (for use with CloFixedPanels)
		 */
		fixed: {
			type: Boolean,
			default: false,
		},
		/**
		 * Use display:flex to control sections
		 */
		flex: {
			type: Boolean,
			default: false,
		},
		/**
		 * Full width (on very large screens)
		 */
		full: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		classes: function () {
			let classes = [];
			const prefix = 'Page--';
			// elevation
			if (this.elevation) {
				classes.push(prefix + 'elevation');
			}
			// flex
			if (this.flex) {
				classes.push(prefix + 'flex');
			}
			// full
			if (this.full) {
				classes.push(prefix + 'full');
			}
			// fixed
			if (this.fixed) {
				classes.push(prefix + 'fixed');
			}
			// background
			if (this.background) {
				classes.push(prefix + this.background);
			}
			return classes.join(' ');
		},
	},
};
</script>

<style lang="scss">
.Page {
	max-width: $page-size;
	background-color: $color-white;
	margin: 0 auto;

	/* Elevation variant adds a dropshadow */
	&--elevation {
		-webkit-box-shadow: 0px 0px 13px 3px rgba(0, 0, 0, 0.23);
		-moz-box-shadow: 0px 0px 13px 3px rgba(0, 0, 0, 0.23);
		box-shadow: 0px 0px 13px 3px rgba(0, 0, 0, 0.23);
	}
	/* Full variant removes the max-width */
	&--full {
		max-width: 100vw;
	}

	/* Flex variant turns page into a flex column */
	&--flex {
		display: flex;
		flex-direction: column;
		min-height: 100%; // Page fills height of screen

		.Page-section--footer {
			margin-top: auto;
		}
	}

	/* Neutral light variant makes the page background light grey */
	&--neutralLight {
		background-color: $color-neutral-0;
	}
	/* Neutral dark variant makes the page background dark grey */
	&--neutralDark {
		background-color: $color-neutral-5;
	}

	&--fixed {
		position: relative;
		height: 100vh; /* Fallback for browsers that do not support Custom Properties */
		height: calc(var(--vh, 1vh) * 100);
	}
}
</style>
